<script>
import { Bar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    options: {
      resposive: false,
      maintainAspectRatio: true,
    },
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/BarChart.vue